<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions } from "vuex";
import AlertError from "@/components/alert_error";
import { VueContentLoading } from "vue-content-loading";
import QrCodeCard from "@/components/qr_code_card";

export default {
  page: {
    title: "أستمارة الحج",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, AlertError, VueContentLoading, QrCodeCard },
  data() {
    return {
      title: "تفاصيل الاستمارة",
      items: [
        {
          text: "الرئيسيه",
          href: "/",
        },
        {
          text: "أستمارة الحج",
          href: "/pilgrimage/sacrificers",
        },
        {
          text: "التفاصيل",
          active: true,
        },
      ],

      //Page errors.
      errors: [],

      id: this.$route.params.id,
      loadingContent: true,
      sacrificer: null,
      qrCodeContent: null,
      showAlert: false,
    };
  },
  computed: {
    ...mapGetters("pilgrimageSacrificer", ["getSacrificer"]),
  },
  methods: {
    ...mapActions("pilgrimageSacrificer", ["get"]),
    handleError(error) {
      alert(error);
      this.showAlert = true;
      if (error.response.status == 422)
        this.errors = Object.values(error.response.data.errors);
      else
        this.errors = [
          `Error Code : ${error.response.status}  Message : ${error.response.data.message}`,
        ];
    },
    fetch() {
      this.get(this.id)
        .then(() => {
          this.sacrificer = this.getSacrificer;
          this.loadingContent = false;

          this.qrCodeContent = JSON.stringify({
            Id: this.sacrificer.qr_id,
            fullName: this.sacrificer.full_name,
            date: this.sacrificer.created_at,
          });
        })
        .catch((error) => {
          this.handleError(error);
          this.loadingContent = false;
        });
    },
    getDiseases() {
      return this.sacrificer.beneficiary.emergency_information.diseases
        .map((d) => d.title)
        .join(" , ");
    },
  },
  created() {
    this.fetch();
  },
  mounted() {
    // setTimeout(() => {
    //   this.loadingContent = false;
    // }, 1000);
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-md-12">
        <AlertError :showDismissibleAlert="showAlert" :errors="errors"></AlertError>

        <div class="card">
          <div v-if="!loadingContent" class="card-body">
            <hr class="hr-title" />
            <div class="break-title"><h5 class="mb-2">بيانات المضحي الشخصية</h5></div>
            <div class="row about-list">
              <h4>{{ sacrificer.full_name }}</h4>
              <div class="col-md-6">
                <div class="media">
                  <label>اللقب :</label>
                  <p>{{ sacrificer.family_name }}</p>
                </div>
                <div class="media">
                  <label>اسم الام الثلاثي :</label>
                  <p>{{ sacrificer.mother_name }}</p>
                </div>
                <div class="media">
                  <label>المحافظة :</label>
                  <p>{{ sacrificer.city.title }}</p>
                </div>
                <div class="media">
                  <label>الفئة :</label>
                  <p>{{ sacrificer.sacrificer_category.title }}</p>
                </div>
              </div>
              <div class="col-md-6">
                <div class="media">
                  <label v-if="sacrificer.sacrificer_category.id == 2"
                    >تاريخ الاصابة :</label
                  >
                  <label v-else>تاريخ الاستشهاد :</label>
                  <p>{{ sacrificer.date_wound }}</p>
                </div>
                <div class="media">
                  <label>التشكيل :</label>
                  <p>{{ sacrificer.dept }}</p>
                </div>
                <div v-if="sacrificer.sacrificer_category.id == 2" class="media">
                  <label>نسبة العجز :</label>
                  <p>{{ sacrificer.disability_ratio }}</p>
                </div>
              </div>
            </div>

            <hr class="hr-title" />
            <div class="break-title">
              <h5 class="mb-2">معلومات المستفيد ( الحاج )</h5>
            </div>
            <div class="row about-list">
              <h4>{{ sacrificer.beneficiary.beneficiary_passport.full_name }}</h4>
              <div class="col-md-6">
                <div class="media" v-if="sacrificer.sacrificer_category.id == 1">
                  <label> صلة القرابة :</label>
                  <p>{{ sacrificer.beneficiary.relation_relative.title }}</p>
                </div>
                <div class="media">
                  <label> المذهب :</label>
                  <p>{{ sacrificer.beneficiary.doctrine.title }}</p>
                </div>
                <div class="media">
                  <label> القومية :</label>
                  <p>
                    {{
                      sacrificer.beneficiary.nationalism
                        ? sacrificer.beneficiary.nationalism.title
                        : ""
                    }}
                  </p>
                </div>
                <div class="media">
                  <label> رقم الهاتف :</label>
                  <p>{{ sacrificer.beneficiary.phone1 }}</p>
                </div>
                <div class="media">
                  <label> رقم الهاتف الاحتياطي :</label>
                  <p>{{ sacrificer.beneficiary.phone2 }}</p>
                </div>
                <div class="media">
                  <label> رقم البطاقة الوطنية :</label>
                  <p>{{ sacrificer.beneficiary.nationalIdnumber }}</p>
                </div>
              </div>
              <div class="col-md-6">
                <div class="media" v-if="sacrificer.sacrificer_category.id == 1">
                  <label> اسم الدائرة الحكومية :</label>
                  <p>{{ sacrificer.beneficiary.board_name }}</p>
                </div>
                <div class="media">
                  <label> طريقة النقل :</label>
                  <p>{{ sacrificer.beneficiary.transportation_type.title }}</p>
                </div>
                <div class="media">
                  <label> هل ذهب الى الحج سابقا :</label>
                  <p>
                    {{ Boolean(sacrificer.beneficiary.is_do_pilgrimaged) ? "نعم" : "لا" }}
                  </p>
                </div>
                <div class="media">
                  <label> هل ذهب المستفيد الى الحج عن طريق الهيأة سابقا :</label>
                  <p>{{ Boolean(sacrificer.beneficiary.is_benefited) ? "نعم" : "لا" }}</p>
                </div>
                <div class="media">
                  <label> هل يوجد احد من ذوي الشهيد مستفيد من خدمة الحج سابقا :</label>
                  <p>{{ Boolean(sacrificer.beneficiary.is_do_beneficiaries_pilgrimaged) ? "نعم" : "لا" }}</p>
                </div>
                <div class="media" v-show="Boolean(sacrificer.beneficiary.is_do_beneficiaries_pilgrimaged)">
                  <label> اسم المستفيد من خدمة الحج سابقا :</label>
                  <p>{{ sacrificer.beneficiary.beneficiary_name }}</p>
                </div>
                <div class="media" v-show="Boolean(sacrificer.beneficiary.is_do_beneficiaries_pilgrimaged)">
                  <label> السنة التي ذهب بها المستفيد الى الحج سابقا :</label>
                  <p>{{ sacrificer.beneficiary.pilgraimage_year }}</p>
                </div>
              </div>
            </div>

            <hr class="hr-title" />
            <div class="break-title">
              <h5 class="mb-2">بيانات جواز السفر للمستفيد ( الحاج )</h5>
            </div>
            <div class="row about-list">
              <div class="col-md-4">
                <div class="media">
                  <label>الاسم الثلاثي :</label>
                  <p>{{ sacrificer.beneficiary.beneficiary_passport.full_name }}</p>
                </div>
                <div class="media">
                  <label>الاسم الاول بالانجليزي :</label>
                  <p>{{ sacrificer.beneficiary.beneficiary_passport.first_name_en }}</p>
                </div>
                <div class="media">
                  <label>رقم الجواز :</label>
                  <p>{{ sacrificer.beneficiary.beneficiary_passport.number }}</p>
                </div>
              </div>
              <div class="col-md-4">
                <div class="media">
                  <label>اللقب :</label>
                  <p>{{ sacrificer.beneficiary.beneficiary_passport.family_name }}</p>
                </div>
                <div class="media">
                  <label>اللقب بالانجليزي :</label>
                  <p>{{ sacrificer.beneficiary.beneficiary_passport.family_name_en }}</p>
                </div>
                <div class="media">
                  <label>تاريخ التولد :</label>
                  <p>{{ sacrificer.beneficiary.beneficiary_passport.birth_date }}</p>
                </div>
              </div>
              <div class="col-md-4">
                <div class="media">
                  <label>اسم الام الثلاثي :</label>
                  <p>{{ sacrificer.beneficiary.beneficiary_passport.mother_name }}</p>
                </div>
                <div class="media">
                  <label>الجنس :</label>
                  <p>{{ sacrificer.beneficiary.beneficiary_passport.gender.title }}</p>
                </div>
                <div class="media">
                  <label>تاريخ اصدار الجواز :</label>
                  <!-- <p>{{ sacrificer.beneficiary.beneficiary_passport. }}</p> -->
                </div>
                <div class="media">
                  <label>تاريخ نفاذ الجواز :</label>
                  <p>{{ sacrificer.beneficiary.beneficiary_passport.expire_date }}</p>
                </div>
              </div>
            </div>

            <hr class="hr-title" />
            <div class="break-title">
              <h5 class="mb-2">بيانات السكن للمستفيد ( الحاج )</h5>
            </div>
            <div class="row about-list">
              <div class="col-md-4">
                <div class="media">
                  <label>المحافظة :</label>
                  <p>{{ sacrificer.beneficiary.beneficiary_address.city.title }}</p>
                </div>
                <div class="media">
                  <label>المحلة :</label>
                  <p>{{ sacrificer.beneficiary.beneficiary_address.mahla }}</p>
                </div>
              </div>
              <div class="col-md-4">
                <div class="media">
                  <label>القضاء :</label>
                  <p>{{ sacrificer.beneficiary.beneficiary_address.district }}</p>
                </div>
                <div class="media">
                  <label>الزقاق :</label>
                  <p>{{ sacrificer.beneficiary.beneficiary_address.zqaq }}</p>
                </div>
              </div>
              <div class="col-md-4">
                <div class="media">
                  <label>المنطقة :</label>
                  <p>{{ sacrificer.beneficiary.beneficiary_address.region }}</p>
                </div>
                <div class="media">
                  <label>الدار :</label>
                  <p>{{ sacrificer.beneficiary.beneficiary_address.dar }}</p>
                </div>
              </div>
            </div>

            <hr class="hr-title" />
            <div class="break-title">
              <h5 class="mb-2">بيانات الطوارئ للمستفيد ( الحاج )</h5>
            </div>
            <div class="row about-list">
              <div class="col-md-4">
                <div class="media">
                  <label>الاسم الثلاثي :</label>
                  <p>
                    {{
                      sacrificer.beneficiary.emergency_information.beneficiary_full_name
                    }}
                  </p>
                </div>
                <div class="media">
                  <label>صلة القرابة :</label>
                  <p>
                    {{ sacrificer.beneficiary.emergency_information.relation_relative }}
                  </p>
                </div>
              </div>
              <div class="col-md-4">
                <div class="media">
                  <label>رقم الهاتف :</label>
                  <p>{{ sacrificer.beneficiary.emergency_information.phone }}</p>
                </div>
                <div class="media">
                  <label>ملاحظات :</label>
                  <p>{{ sacrificer.beneficiary.emergency_information.note }}</p>
                </div>
              </div>
              <div class="col-md-4">
                <div class="media">
                  <label>هل لديه مرض مزمن :</label>
                  <p>
                    {{
                      sacrificer.beneficiary.emergency_information.is_have_disease
                        ? "نعم"
                        : "لا"
                    }}
                  </p>
                </div>
                <div
                  v-if="sacrificer.beneficiary.emergency_information.diseases.length > 0"
                  class="media"
                >
                  <label>الامراض :</label>
                  <p>{{ getDiseases() }}</p>
                </div>
              </div>
            </div>

            <hr class="hr-title" />
            <div class="break-title"><h5 class="mb-2">تنزيل المرفقات</h5></div>
            <div class="row about-list">
              <div class="col-md-12">
                <a
                  v-if="sacrificer.sacrificer_category.id == 1"
                  :href="sacrificer.beneficiary.beneficiary_attachment.url_qssam"
                  target="_blank"
                >
                  <b-button
                    :disabled="!sacrificer.beneficiary.beneficiary_attachment.url_qssam"
                    variant="primary"
                    type="button"
                    class="me-2"
                    >مرفق القسام الشرعي</b-button
                  >
                </a>
                <a
                  v-if="sacrificer.sacrificer_category.id == 2"
                  :href="sacrificer.beneficiary.beneficiary_attachment.url_wounded"
                  target="_blank"
                >
                  <b-button
                    :disabled="!sacrificer.beneficiary.beneficiary_attachment.url_wounded"
                    variant="primary"
                    type="button"
                    class="me-2"
                    >مرفق قرار اللجنة الطبية</b-button
                  >
                </a>
                <a
                  :href="sacrificer.beneficiary.beneficiary_attachment.url_passport"
                  target="_blank"
                >
                  <b-button
                    :disabled="
                      !sacrificer.beneficiary.beneficiary_attachment.url_passport
                    "
                    variant="primary"
                    type="button"
                    class="me-2"
                    >مرفق جواز السفر</b-button
                  >
                </a>
                <a
                  :href="sacrificer.beneficiary.beneficiary_attachment.url_national"
                  target="_blank"
                >
                  <b-button
                    :disabled="
                      !sacrificer.beneficiary.beneficiary_attachment.url_national
                    "
                    variant="primary"
                    type="button"
                    class="me-2"
                    >مرفق البطاقة الوطنية</b-button
                  >
                </a>
                <a
                  :href="sacrificer.beneficiary.beneficiary_attachment.url_address"
                  target="_blank"
                >
                  <b-button
                    :disabled="!sacrificer.beneficiary.beneficiary_attachment.url_address"
                    variant="primary"
                    type="button"
                    class="me-2"
                    >مرفق بطاقة السكن</b-button
                  >
                </a>
                <a
                  :href="sacrificer.beneficiary.beneficiary_attachment.url_vaccine_card"
                  target="_blank"
                >
                  <b-button
                    :disabled="
                      !sacrificer.beneficiary.beneficiary_attachment.url_vaccine_card
                    "
                    variant="primary"
                    type="button"
                    class="me-2"
                    >مرفق بطاقة اللقاح</b-button
                  >
                </a>
              </div>
            </div>

            <QrCodeCard
              title="استمارة الحج"
              :fullName="this.sacrificer.beneficiary.beneficiary_passport.full_name"
              :date="this.sacrificer.created_at"
              :Id="this.sacrificer.qr_id"
              :qrCodeContent="this.qrCodeContent"
            ></QrCodeCard>

            <div class="mt-3">
              <hr />
              <b-button
                class=""
                type="button"
                to="/pilgrimage/sacrificers"
                variant="secondary"
                >رجوع</b-button
              >
            </div>
          </div>

          <!-- loading content -->
          <div v-else>
            <vue-content-loading :rtl="true" :width="400" :height="110">
              <rect x="85" y="10" rx="1" ry="1" width="30" height="2" />
              <rect x="275" y="10" rx="1" ry="1" width="30" height="2" />
              <rect x="6" y="15" rx="1" ry="1" width="194" height="2" />
              <rect x="200" y="16" rx="1" ry="1" width="194" height="1" />

              <rect x="10" y="25" rx="1" ry="1" width="50" height="5" />
              <rect x="340" y="25" rx="1" ry="1" width="50" height="5" />

              <rect x="10" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="66" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="122" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="178" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="234" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="290" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="346" y="40" rx="2" ry="2" width="44" height="5" />
              <rect x="10" y="49" rx="1" ry="1" width="380" height="1" />

              <rect x="10" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="66" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="122" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="178" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="234" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="290" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="346" y="54" rx="2" ry="2" width="44" height="5" />
              <rect x="10" y="63" rx="1" ry="1" width="380" height="1" />

              <rect x="10" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="66" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="122" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="178" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="234" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="290" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="346" y="68" rx="2" ry="2" width="44" height="5" />
              <rect x="10" y="77" rx="1" ry="1" width="380" height="1" />

              <rect x="10" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="66" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="122" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="178" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="234" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="290" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="346" y="82" rx="2" ry="2" width="44" height="5" />
              <rect x="10" y="91" rx="1" ry="1" width="380" height="1" />
              <circle cx="340" cy="100" r="1" />
              <circle cx="350" cy="100" r="1" />
              <circle cx="363" cy="100" r="4" />
              <circle cx="376" cy="100" r="1" />
              <circle cx="386" cy="100" r="1" />
            </vue-content-loading>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
